import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { CguService } from 'src/app/services/api/cgu.service';
import { DownloadService } from 'src/app/services/download.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-cgu',
    templateUrl: './cgu.component.html',
    styleUrls: ['./cgu.component.scss']
})

export class CguComponent implements OnInit {

    public title: string = "Medimail Patient - Validation CGU";

    public errorMessage: string = "";
    public errorType: string = "";

    public cguList: Array<string> = [];

    constructor(private cguS: CguService,
                private userService: UserService,
                private route: Router,
                private downloadService: DownloadService,
                private titleService: Title)
    {
        this.titleService.setTitle(this.title);
    }

    ngOnInit(): void
    {        
        this.cguS.getCgu().subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.cguList = res.content;
            }
        });
    }

    async validateCgu() {
        await this.cguS.validateCgu().then(
            (res) => {
                if (res.result == "SUCCESS") {
                    this.userService.currentUser.cgu = false;
                    this.route.navigate(['/folders', this.userService.currentUser.symfonyUser.defaultFolder]);
                } else {
                    this.errorMessage = res.content;
                    this.errorType = res.result;
                }
            }, (resError) => {
                this.userService.logout();
            }
        )
    }

    refuseCgu() {
        this.userService.logout();
    }

    downloadFile(fileName: string)
    {
        this.downloadService.downloadFile(fileName).subscribe(blob => {
            saveAs(blob, fileName);
        }, (error) => {
            this.errorType = 'ERROR';
            this.errorMessage = 'ERRORS.DOWNLOAD-FILE';
        });
    }
}
